import styled from 'styled-components';
import Button from '@wconcept/wconcept-ui-renewal/components/atoms/Button';
import Lottie from 'react-lottie-player';
import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

export const ShortFormBtn = styled(Button)`
  overflow: hidden;
  width: 36px;
  height: 36px;
  border-radius: 6px;
  background: linear-gradient(91.75deg, #ff3d22 0.33%, #f01478 98.02%);

  @media ${({ theme }) => theme.media.smMax} {
    width: ${mixin.pxToVw('36')};
    height: ${mixin.pxToVw('36')};
    border-radius: ${mixin.pxToVw('6')};
  }
`;

export const ShortFormLottie = styled(Lottie)`
  width: 179px;
  margin-bottom: -2px;

  @media ${({ theme }) => theme.media.smMax} {
    width: ${mixin.pxToVw('179')};
    margin-bottom: ${mixin.pxToVw('-2')};
  }
`;
